import { PopupMessage } from 'src/shared/types/types';
import './PopupMessages.scss';
import Popup from './popup/Popup';

export interface PopupMessagesProps {
  messages: PopupMessage[];
  onClosePopup: (id: string) => void;
}

export function PopupMessages({
  messages,
  onClosePopup,
}: PopupMessagesProps) {
  return (
    <div className="popup-message-collection">
      {messages.map((message, index) => (
        <Popup
          key={message.id}
          popupId={message.id}
          popupMessage={message}
          onClosePopup={() => onClosePopup(message.id)}
          style={{ marginLeft: `${index * 10}px` }}
        />
      ))}
    </div>
  );
}
